import dayjs from 'dayjs'
import moment from 'moment'

export const startDate =  moment(new Date()).format('YYYY-MM-DD')
export const endDate = moment(new Date()).format('YYYY-MM-DD')